/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageMapPage
 */
define(['module',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/text!./templates/SignageMapPage.html',
        'idis/map/IdisMap',
        'idis/service/Requester',
        '../_SignageBase',
        'app/config',
        'app/model/LayerStore',
        'idis/control/Locator',
        'dojo/_base/array',
        'idis/consts/QUERY',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, declare, lang, template, IdisMap, Requester, _SignageBase, config, LayerStore, Locator, array, QUERY) {
        /**
         *
         * @class SignageMapPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageMapPage~SignageMapPage# */
        {
            // テンプレート文字列
            templateString: template,

            store: null,

            // レイヤーID
            _layerId: [],

            // 緯度経度
            _latlng: null,

            // ズーム
            _zoom: null,

            _layerControl: null,

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
            },

            /**
             * 画面表示
             */
            initPage: function() {

                Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this,function(data) {
                    var item = data;
                    this._version = item.version;
                    // レイヤー
                    this._layerId = item.layerId;
                    // 緯度経度
                    if (item.latitude && item.longitude) {
                        this._latlng = [item.latitude, item.longitude];
                    } else {
                        this._latlng = [config.map.latitude, config.map.longitude];
                    }
                    // ズーム
                    if (item.zoom) {
                        this._zoom = item.zoom;
                    } else {
                        this._zoom = 11;
                    }
    
                    // マップを初期化
                    this.initMap();
                    // レイヤーを表示
                    this.showLayer();
                    // レイヤーの表示
                    this.displayLayer();
                    
                }), function(error) {
                    // 処理失敗時はエラーログを出力し、エラーダイアログを表示
                    console.error(error);
                    this.chain.infoError(error);
                });
            },

            initMap: function () {

                // マップの初期化
                this.map = new IdisMap(this.id + '-map', {
                    config: config.map,
                    keyboard: false, // コメント時に+/-が使用できないため
                    touchExtend: false, // IE対応
                    minZoom: 9,
                    maxZoom: 18,
                    drawControlTooltips: false
                }).setView(this._latlng, this._zoom);

                // mapのdestroyはremoveでDojoと互換なのでownで消せる
                this.own(this.map);

                this._layerControl = this.map.layerControl;

            },

            showLayer: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    var layerQuery = {};

                    // jsonのitemsを表示対象レイヤーとする
                    array.forEach(item.items, function(layerId) {
                        layerQuery[layerId] = layerQuery[layerId] || '0';
                    }, this);

                    // URLに反映
                    Locator.replaceState(QUERY.LAYER_LIST, Locator.toLayerQuery(layerQuery));
                }), lang.hitch(this, function (error) {
                    self.chain.infoError(error);
                }));
            },

            displayLayer: function() {
                // 非表示
                lang.hitch(this, function() {
                    array.forEach(this._layerControl.getLayers(), function(layer) {
                        this._layerControl.removeLayer(layer);
                    });
                });
                // 再表示
                var layerIdList = this._layerId;
                lang.hitch(this, function() {
                    array.forEach(layerIdList, function(layerId) {
                        LayerStore.get(layerId).then(lang.hitch(this, function(layerInfo) {
                            this._layerControl.addGeneralLayer(layerInfo, 0);
                        }));
                    });
                });
            }
        });
    });
